// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';

export default Styled.span`
  font-family: Nunito;
  text-align: left;
  font-size: 11px;
  ${(props) =>
    props.type === 'left' &&
    `
    color: ${props.theme.colors.PROMO.ORANGE};
    font-weight: 700;
  `}
  ${(props) =>
    props.type === 'middle' &&
    `
    font-size: 13px;
    color: ${props.theme.colors.BLACK}
    font-weight: 400;
    padding: 0 3px;
  `}
  ${(props) =>
    props.type === 'right' &&
    `
    color: ${props.theme.colors.PROMO.BLUE};
    font-weight: 700;
  `}
`;
